import { actionCopyDe } from "./actionCopy";

export const diaryCopyDe = {
    diaries: "Tagebücher",
    diary: "Tagebuch",
    diaryPeriod: "Tagebuchzeitraum",
    toDo: "Zu erledigen",
    results: "Ergebnisse",
    toNow: "- Heute",
    edit: actionCopyDe.edit,
    change: "Ändern",
    details: "Details",
    deleteEntry: "Eintrag löschen",
    done: actionCopyDe.done,
    next: actionCopyDe.next,
    save: actionCopyDe.save,
    saving: actionCopyDe.saving,
    cancel: actionCopyDe.cancel,
    date: "Datum",
    time: "Uhrzeit",
    noSteps: "Keine Schritte.",
    step: "Schritt",
    chooseStep: "Schritt auswählen",
    currently: "Aktuell",
    general: "Allgemein",
    procedureDetails: "Behandlungsdetails",
    hospitalReferenceNumber: "Krankenhaus-Referenznummer",
    hospitalNumber: "Krankenhausnummer",
    hospitalNumberDescription: "Krankenhaus-Referenznummer für alle Fragebögen.",
    enterHospitalNumber: "Krankenhausnummer eingeben",
    startDate: "Startdatum",
    procedureDate: "Behandlungsdatum",
    referenceDate: "Referenzdatum",
    referenceDateDescription: "Das Datum der Injektion, Operation oder anderen Behandlung.",
    baselineDate: "Ausgangsdatum",
    baselineDateDescription:
        "Das Datum, ab dem die Nachbeobachtung gemessen wird, z. B. der Studieneinschluss. Die Fragebögen werden ab diesem Datum geplant.",
    patientBaselineDate: "Startdatum",
    patientBaselineDateDescription: "Ab diesem Datum werden Ihre Folgefragen geplant.",
    eventDateDescription: "Die Folgefragebögen werden ab diesem Datum geplant.",
    patientEventDateDescription: "Ihre Folgefragen werden ab diesem Datum geplant.",
    endDate: "Enddatum",
    contactPerson: "Kontaktperson",
    contactPersonDescription:
        "Hauptkontakt für dieses Tagebuch. Tippen Sie auf Kopieren, um die E-Mail-Adresse zu kopieren.",
    loadingContact: "Kontakt wird geladen...",
    side: "Seite",
    anatomicArea: "Anatomischer Bereich",
    questionnaireSide: "Fragebogenseite",
    questionnaireSideDescription: "Auf welche Seite sich dieser Fragebogen bezieht.",
    notSet: "Nicht festgelegt",
    trackerSettings: "Fragebogen-Einstellungen",
    consent: "Einwilligung",
    consentForm: "Einwilligungsformular",
    consentDetails: "Details",
    openConsent: "Einwilligung öffnen",
    sign: "Unterschreiben",
    signed: "Unterschrieben",
    signedAt: (date) => `Unterschrieben am ${date}`,
    requiresSignature: "Unterschrift erforderlich",
    actionRequiredSignConsent: "Aktion erforderlich: Einwilligung unterschreiben",
    signConsentBeforeContinuing: (count) =>
        `Sie müssen ${count > 1 ? "die folgenden Einwilligungsformulare" : "das folgende Einwilligungsformular"} unterschreiben, bevor Sie fortfahren:`,
    signConsentNow: "Einwilligung jetzt unterschreiben",
    detailsStillNeed: "Details, die wir noch benötigen",
    detailsStillNeedDescription:
        "Bitte vervollständigen Sie diese Angaben. Falls die Seite noch fehlt, fragen wir im Einrichtungsbildschirm danach.",
    injectionSide: "Injektionsseite",
    injectionAnatomicArea: "Anatomischer Bereich der Injektion",
    surgerySide: "Operationsseite",
    shockwaveSide: "Stoßwellenseite",
    shockwaveAnatomicArea: "Anatomischer Bereich der Stoßwelle",
    yourEntries: "Ihre Einträge",
    noDiary: "Kein Tagebuch",
    noCompletedEntries: "Noch keine abgeschlossenen Einträge.",
    form: "Formular",
    forms: "Formulare",
    item: "Eintrag",
    items: "Einträge",
    questionnaire: "Fragebogen",
    questionnaires: "Fragebögen",
    injection: "Injektion",
    surgery: "Operation",
    shockwave: "Stoßwelle",
    consultation: "Beratung",
    procedure: "Behandlung",
    procedures: (count) => `${count} Behandlungen`,
    task: "Aufgabe",
    tasks: "Aufgaben",
    toDoEmpty: "Sie sind auf dem neuesten Stand - im Moment ist nichts zu erledigen.",
    blocked: "Wartet auf frühere Formulare",
    blockedEmpty: "Keine Formulare warten auf frühere Schritte.",
    formsLockedUntilConsentSigned:
        "Ihre Formulare werden freigeschaltet, nachdem Sie die erforderliche Einwilligung unterschrieben haben.",
    completePreviousFormFirst: (formName) => `Zuerst ${formName} ausfüllen`,
    doneEmpty: "Abgeschlossene Schritte erscheinen hier.",
    complete: "Abgeschlossen",
    due: "Fällig",
    upToDate: "Aktuell",
    allCaughtUp: "Alles erledigt",
    formsNeedAttention: "Formulare erfordern Aufmerksamkeit",
    progress: "Fortschritt",
    completed: "Abgeschlossen",
    notNeeded: "Nicht erforderlich",
    dueNow: "Jetzt fällig",
    waiting: "Wartet",
    locked: "Gesperrt",
    lockedByEarlierEntry: "Gesperrt - zuerst einen früheren Eintrag ausfüllen",
    lockedUntilPreviousFormComplete: (formName) => `Gesperrt - zuerst ${formName} ausfüllen`,
    availableLater: "Später verfügbar",
    nextDue: "Als Nächstes fällig",
    dueOn: (date) => `Fällig am ${date}`,
    nextScheduledSentence: (formLabel, scheduleLabel, date) => {
        const schedule = scheduleLabel.trim();
        const due = date.trim();
        const timing = schedule ? ` für ${schedule}` : "";
        if (due) return `Als Nächstes ist Ihr ${formLabel}${timing} am ${due} fällig.`;
        return `Als Nächstes ist Ihr ${formLabel}${timing} fällig.`;
    },
    noEntriesScheduled: "Noch keine Einträge geplant.",
    showLess: "Weniger anzeigen",
    showMore: (count) => `Mehr anzeigen (${count} weitere ${count === 1 ? "Zeitangabe" : "Zeitangaben"})`,
    showAllTimings: (count) => `Alle ${count} Zeitangaben anzeigen`,
    expand: "Erweitern",
    submitted: (completed, total) => `${completed} von ${total} eingereicht`,
    submittedOn: (date) => `Eingereicht am ${date}`,
    noDataYet: "Noch keine Daten",
    noDataDescription: "Fügen Sie Einträge hinzu, um Ihren Fortschritt im Zeitverlauf zu sehen",
    notEnoughDataYet: "Noch nicht genug Daten",
    notEnoughDataDescription: "Für Diagramme müssen mindestens zwei Einträge vorhanden sein.",
    addEntry: "Eintrag hinzufügen",
    addEntryFor: (formSlug, timingLabel) => `${formSlug} ${timingLabel} Eintrag hinzufügen`,
    addExtraScore: "Zusätzlichen Score hinzufügen",
    addExtraScoreTitle: "Einen zusätzlichen Score erfassen",
    addExtraScoreDescription:
        "Dies ist optional. Fahren Sie nur fort, wenn Sie eine zusätzliche Messung erfassen möchten oder Sie gebeten wurden, sich zu melden.",
    addForm: "Formular hinzufügen",
    entryDue: (label) => `Ihr Eintrag für ${label.toLowerCase()} ist fällig.`,
    nextEntryDueOn: (label, date) => `Ihr Eintrag für ${label.toLowerCase()} ist am ${date} fällig.`,
    entriesDueForForm: (count) => `${count} Einträge für dieses Formular sind fällig.`,
    formWithEntriesDue: (formName, entries) =>
        `${formName}: ${entries} ${entries === 1 ? "fälliger Eintrag" : "fällige Einträge"}. Ihre anderen Formulare sind aktuell.`,
    formsWithEntriesDue: (forms, entries) =>
        `Sie haben ${forms} ${forms === 1 ? "Formular" : "Formulare"} mit ${entries} ${
            entries === 1 ? "fälligem Eintrag" : "fälligen Einträgen"
        }.`,
    allFormsComplete: "Alle Ihre Formulare sind abgeschlossen.",
    allEntriesComplete: "Alle Einträge abgeschlossen",
    entriesDueNow: (count) => `${count} Einträge jetzt fällig`,
    completeYourEntry: (label) => `Vervollständigen Sie Ihren ${label.toLowerCase()}-Eintrag`,
    questionnaireDueNow: "Fragebogen jetzt fällig",
    nextEntryLabel: (label) => `Nächster Eintrag: ${label}`,
    waitingForNextEntry: "Warten auf den nächsten Eintrag",
    readyLabel: (label) => `Bereit: ${label}`,
    readyToComplete: "Bereit zum Ausfüllen",
    reminderText: "Wir senden Ihnen eine SMS, wenn es fällig ist.",
    reminderEmail: "Wir senden Ihnen eine E-Mail, wenn es fällig ist.",
    reminderTextAndEmail: "Wir senden Ihnen eine SMS und eine E-Mail, wenn es fällig ist.",
    reminderNone:
        "Aktivieren Sie SMS- oder E-Mail-Erinnerungen in Ihren Einstellungen, wenn Sie erinnert werden möchten.",
    entrySubmitted: "Eintrag übermittelt.",
    completeWithCareTeam: "Abgeschlossen und wartet auf Prüfung.",
    formNumber: (index) => `Formular ${index}`,
    dateOfProcedure: (phrase) => `Datum der ${phrase}`,
    wrongDate: "Falsches Datum?",
    editHere: "Hier bearbeiten",
    showAnswers: "Antworten anzeigen",
    hideAnswers: "Antworten ausblenden",
    showAnswersDescription:
        "Antworten anzeigen oder auf Ändern bei einem Zeitpunkt tippen, um Antworten zu aktualisieren",
    entryCountLabel: (count) => (count === 1 ? "1 Eintrag" : `${count} Einträge`),
    timing: "Zeitpunkt",
    referredBy: (name) => `Überwiesen von: ${name}`,
    performedBy: (name) => `Durchgeführt von: ${name}`,
    method: (method) => `Methode: ${method}`,
    injectionDetails: "Injektionsdetails",
    unknown: "Unbekannt",
    noDateSpecified: "Kein Datum angegeben",
    noInjectionDetails: "Keine Injektionsdetails angegeben.",
    sideNotSpecified: "Seite nicht angegeben",
    areaNotSpecified: "Bereich nicht angegeben",
    siteNotSpecified: "Lokalisation nicht angegeben",
    substanceNotSpecified: "Substanz nicht angegeben",
    blankAnswer: "Nicht ausgefüllt",
    listEmptyTitle: "Noch keine Tagebücher",
    listEmptyDescription: "Für Sie angelegte Tagebücher erscheinen hier",
    listCheckAgain: "Erneut prüfen",
    listNeedsAttention: "Erfordert Ihre Aufmerksamkeit",
    listNeedsAttentionDescription: "Tagebücher mit Formularen, die auf Ihren nächsten Eintrag warten.",
    listOngoing: "Laufend",
    listOngoingDescription: "Tagebücher, die laufen oder auf Ihren ersten Eintrag warten.",
    listUpToDateDescription: "Laufende Tagebücher ohne fällige Einträge.",
    listNoOngoing: "Derzeit keine laufenden Tagebücher",
    listCompletedDescription: "Tagebücher, die beendet sind (es werden keine weiteren Einträge erfasst).",
    listNoCompleted: "Noch keine abgeschlossenen Tagebücher",
    listOpenDiary: "Tagebuch öffnen",
    listReviewDiary: "Tagebuch ansehen",
};
